module.exports = __webpack_public_path__ + "img/productHead.91dcc838.png";